import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { audienceItems } from '../../data/salesContent';
export function AudienceSection() {
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-53" data-mp="96np8e4lkh32">
      <div className="mx-auto max-w-3xl" data-id="element-54" data-mp="941iggpj65lw">
        <SectionHeading title="Este sistema es para vos si..." data-id="element-55" data-mp="472rg715yerx" />
        <ul className="mt-12 divide-y divide-ink-line border-y border-ink-line" data-id="element-56" data-mp="3cn47zd6ir12r">
          {audienceItems.map(item => <CheckItem key={item} className="py-5 text-lg leading-snug text-cream md:text-xl" data-id="element-57" data-mp="38m2gjiiuftbc">
              {item}
            </CheckItem>)}
        </ul>
      </div>
    </section>;
}